import { useState, useEffect } from 'react';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/a534c01bb3b46d379273c3213a43e3eb.jpg',
    alt: 'Family-focused homeowner with child'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20African%20American%20family%20together%20in%20spacious%20bright%20modern%20living%20room%20with%20large%20energy%20efficient%20windows%20warm%20natural%20sunlight%20happy%20joyful%20moment%20parents%20and%20children%20laughing%20together%20premium%20contemporary%20home%20interior%20cinematic%20lifestyle%20photography%20shallow%20depth%20of%20field%20warm%20tones%20high%20end%20residential&width=1920&height=1080&seq=hero-slide-black-family&orientation=landscape',
    alt: 'African American family in modern home'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20African%20American%20mother%20with%20young%20child%20in%20beautiful%20sunlit%20modern%20kitchen%20with%20new%20large%20windows%20natural%20light%20streaming%20in%20warm%20loving%20moment%20child%20on%20hip%20smiling%20confident%20expression%20premium%20contemporary%20home%20interior%20cinematic%20lifestyle%20photography%20shallow%20depth%20of%20field%20warm%20inviting%20atmosphere%20high%20end%20residential&width=1920&height=1080&seq=hero-slide-black-mom-kid&orientation=landscape',
    alt: 'African American mother with child'
  }
];

const PROPOSAL_HREF = 'https://api.leadconnectorhq.com/widget/form/0ZsIY0jYLaF8aXm2FeXI';

export default function Hero() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="home"
      className="relative overflow-hidden pb-20 lg:pb-0"
      style={{ minHeight: '760px', height: '90vh' }}
    >
      {/* Slideshow Background */}
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === activeSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>
        ))}

        {/* Mobile gradient - stronger for readability */}
        <div
          className="absolute inset-0 lg:hidden"
          style={{
            background:
              'linear-gradient(180deg, rgba(0,0,0,0.70) 0%, rgba(0,0,0,0.40) 55%, rgba(0,0,0,0.10) 100%)'
          }}
        />

        {/* Desktop gradient - left-side */}
        <div
          className="absolute inset-0 hidden lg:block"
          style={{
            background:
              'linear-gradient(90deg, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.25) 45%, rgba(0,0,0,0.0) 70%)'
          }}
        />
      </div>

      {/* Hero Content */}
      <div className="absolute inset-0 flex items-start">
        <div className="w-full mx-auto px-5 sm:px-8 lg:px-24 pt-24 sm:pt-32 lg:pt-40">
          
          {/* Content wrapper - constrained on mobile */}
          <div className="max-w-[320px] sm:max-w-[560px] mx-auto lg:mx-0">

            {/* H1 - mobile optimized */}
            <h1
              className="font-bold text-white mb-3 sm:mb-4"
              style={{
                fontSize: 'clamp(34px, 8vw, 64px)',
                lineHeight: '1.1',
                letterSpacing: '-0.02em',
                fontWeight: 700
              }}
            >
              The Future of How Homeowners Buy Windows
            </h1>

            {/* Subhead - mobile optimized */}
            <p
              className="text-white mb-4 sm:mb-5"
              style={{
                fontSize: 'clamp(16px, 4vw, 20px)',
                lineHeight: '1.55',
                fontWeight: 450
              }}
            >
              Transform your home with custom replacement windows in a{' '}
              <strong style={{ fontWeight: 700 }}>SNAP</strong>.
            </p>

            {/* Trust line - mobile optimized */}
            <p
              className="text-white/90 mb-5 sm:mb-6"
              style={{
                fontSize: 'clamp(14px, 3.5vw, 16px)',
                lineHeight: '1.5',
                fontWeight: 400
              }}
            >
              <strong style={{ fontWeight: 700 }}>NO MONEY DOWN.</strong> Pay only after installation —{' '}
              when you&apos;re <strong style={{ fontWeight: 700 }}>100% SATISFIED</strong>.
            </p>

            {/* CTA Button - full width on mobile */}
            <div className="mb-4 sm:mb-5">
              <a
                href={PROPOSAL_HREF}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full lg:w-auto inline-flex items-center justify-center gap-3 bg-white text-[#2B6777] font-bold rounded-[14px] hover:bg-white/95 transition-all cursor-pointer whitespace-nowrap shadow-2xl hover:scale-[1.02] transform"
                style={{
                  fontSize: '16px',
                  height: '52px',
                  padding: '0 24px'
                }}
              >
                Start With Photos
                <i className="ri-camera-line text-lg"></i>
              </a>
            </div>

            {/* Trust Chips — ONLY 2 chips, mobile optimized */}
            <div className="flex flex-wrap items-center gap-2 sm:gap-2.5">
              <div className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-[#D98CA3] rounded-full shadow-md">
                <i className="ri-check-line text-white text-sm"></i>
                <span className="text-white font-bold whitespace-nowrap text-xs sm:text-sm">NO MONEY DOWN</span>
              </div>
              <div className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-[#52AB98] rounded-full shadow-md">
                <i className="ri-check-line text-white text-sm"></i>
                <span className="text-white font-semibold whitespace-nowrap text-xs sm:text-sm">No in-home sales</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveSlide(index)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              index === activeSlide ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/75 w-2'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}